export default __webpack_public_path__ + "static/media/services_dev_android.14bfa7ca.svg";